import { PERMISSIONS } from '@erp/shared';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWorkTab } from '@/app/work-tabs/work-tab-context';
import { usePermissions } from '@/features/auth';
import { ProductFormSheet } from '../components/product-form-sheet';

export function ProductNewRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { can } = usePermissions();

  const tab = useWorkTab({ title: t('workTabs.new.product') });
  if (!can(PERMISSIONS.PRODUCT_WRITE)) return <p role="alert">{t('permissions.deniedTitle')}</p>;
  return (
    <ProductFormSheet
      open
      inline
      product={null}
      onOpenChange={(open) => {
        if (!open) tab.close();
      }}
      onSaved={(saved) => {
        const path = `/products/${saved.id}`;
        tab.update({ path, title: saved.name, dirty: false });
        navigate(path, { replace: true });
      }}
    />
  );
}
